export class AudioVersion {
	public id: number
	public name: string

	constructor(data: { id: number; name: string }) {
		this.id = data.id
		this.name = data.name
	}
}
